import styles from "./Versao.module.css";
import load from "../../../../../Images/loading.gif";
import { useEffect, useState } from "react";

function Versao({ app, venda }) {
    const [plano, setPlano] = useState(null);
    const [changelogs, setChangelogs] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchPlan = async () => {
        try {
            const response = await fetch(`https://eclipsebots.com/api/planos/${venda.systemId}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                },
                credentials: "include"
            });

            if (!response.ok) {
                throw new Error("Failed to fetch plan");
            }

            const data = await response.json();
            setPlano(data[0]);
        } catch (error) {
            console.error("Erro ao buscar plano:", error);
            setPlano(null);
        }
    };

    const fetchChangelogs = async () => {
        try {
            const response = await fetch(`https://eclipsebots.com/api/changelog/${app}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                },
                credentials: "include"
            });

            if (!response.ok) {
                throw new Error("Failed to fetch changelogs");
            }

            const data = await response.json();
            setChangelogs(data); // aqui usamos todos os changelogs
        } catch (error) {
            console.error("Erro ao buscar changelogs:", error);
            setChangelogs([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchPlan();
        fetchChangelogs();
    });

    if (loading || !plano) {
        return <div className={styles.content}>
            <div className={`${styles.size} ${styles.loading}`}>
                <img src={load} width="20px" height="20px" alt="loading" />
            </div>
        </div>
    }

    const currentChangelog = changelogs.find(c => c.version === plano.version);
    const lastUpdate = currentChangelog?.created_at
        ? new Date(currentChangelog.created_at).toLocaleDateString("pt-PT")
        : "Desconhecido";

    return (
        <div>
            <div className={styles.currentVersion}>
                <span className={styles.label}>Versão Atual:</span>
                <span className={styles.value}>{plano.version}</span>
            </div>

            <div className={styles.updated}>
                <span className={styles.label}>Última Atualização:</span>
                <span className={styles.value}>{lastUpdate}</span>
            </div>

            <div className={styles.changelog}>
                <span className={styles.label}>Notas da Versão:</span>
                {currentChangelog ? (
                    <ul>
                        {currentChangelog.description
                            .split("\n")
                            .map((line, idx) => (
                                <li key={idx}>{line}</li>
                            ))}
                    </ul>
                ) : (
                    <p>Sem notas disponíveis para esta versão.</p>
                )}
            </div>

            <div className={styles.history}>
                <span className={styles.label}>Histórico de Versões:</span>
                {changelogs.length === 0 ? (
                    <ul>
                        <li>Não há nenhuma versão disponível</li>
                    </ul>
                ) : (
                    <ul>
                        {changelogs.map((log, index) => (
                            <li key={index}>
                                {log.version} - {new Date(log.created_at).toLocaleDateString("pt-PT")}
                            </li>
                        ))}
                    </ul>
                )}
            </div>
        </div>
    );
}

export default Versao;